import {
  accomFeatureGA,
  accomUpdateBathroomsGA,
  accomUpdateBedroomsGA,
  accomUpdateMaxPriceGA,
  accomUpdateMinPriceGA,
  errorMessageGA,
  paymentCompleteGA,
  paymentErrorGA,
  searchFormSubmitGA,
  searchGA,
  searchResultsFilteringGA,
  togglePetFriendlyGA,
  topUpPaymentGA,
  updateMaxPriceGA,
  updateMinPriceGA,
  viewItemGA,
} from '../../analytics';
import {
  ACCOM_TOGGLE_FILTER,
  ACCOM_UPDATE_BATHROOMS,
  ACCOM_UPDATE_BEDROOMS,
  ACCOM_UPDATE_MAX_VALUE,
  ACCOM_UPDATE_MIN_VALUE,
  TOGGLE_PET_FRIENDLY_SELECTED,
  UPDATE_MAX_VALUE,
  UPDATE_MIN_VALUE,
} from '../appFilterAndSort/action-types';
import { accomFiltersStateArraySelector, petFriendlySelectedSelector } from '../appFilterAndSort/selectors';
import { COMPLETE_BOOKING } from '../booking/booking/action-types';
import { bookingParkDetailsSelector } from '../booking/booking/derivedSelectors';
import {
  bookingIdSelector,
  customBookingPaymentSelector,
  partyBookingSelector,
  typeSelector,
} from '../booking/booking/selectors';
import {
  paymentOptionSelector,
  selectedExtrasWithValuesSelector,
  totalCostDepositSelector,
  totalCostFullSelector,
} from '../booking/form/selectors';
import { POST_PAYMENT } from '../booking/payment/action-types';
import { postPaymentErrorDataSelector } from '../booking/payment/selectors';
import { FAILURE } from '../constants';
import { TOGGLE_OFFER } from '../offers/action-types';
import { allOffersDataSelector, selectedOffersUrnsSelector } from '../offers/selectors';
import { SELECT_PARK } from '../park/action-types';
import { parkDetailsSelector, processedResultsSelector } from '../park/derivedSelectors';
import { START_SEARCH } from '../search/form/action-types';

export const analyticsMiddleware = (store) => (next) => (action) => {
  if (!action || !action.type) {
    return next(action);
  }
  if (action.type.endsWith(FAILURE)) {
    errorMessageGA(action.payload.errors?.message);
  }
  switch (action.type) {
    case TOGGLE_OFFER: {
      const state = store.getState();
      const selectedOffersUrns = selectedOffersUrnsSelector(state);
      const allOffers = allOffersDataSelector(state);
      const stringUrn = action.payload.toString();

      const offerName = allOffers.find(({ urn }) => urn === stringUrn).offer;
      const isSelected = selectedOffersUrns.includes(stringUrn);

      if (offerName) searchResultsFilteringGA(offerName, isSelected, 'Offer');
      break;
    }
    case START_SEARCH: {
      searchFormSubmitGA(action.payload);
      const filteredParams = Object.fromEntries(Object.entries(action.payload).filter(([, v]) => v !== undefined));
      const queryString = new URLSearchParams(filteredParams).toString();
      searchGA(queryString);
      break;
    }
    case COMPLETE_BOOKING: {
      const state = store.getState();
      const bookingType = typeSelector(state);
      const totalCost = totalCostFullSelector(state);
      const bookingId = bookingIdSelector(state);
      const bookingParkDetails = bookingParkDetailsSelector(state);
      const extras = selectedExtrasWithValuesSelector(state);
      const partyBooking = partyBookingSelector(state);
      const deposit = totalCostDepositSelector(state);
      const paymentOption = paymentOptionSelector(state);
      const depositAmount = paymentOption === 'deposit' ? deposit : 0;
      const topUpAmount = customBookingPaymentSelector(state);

      if (bookingType === 'new') {
        paymentCompleteGA(bookingId, totalCost, bookingParkDetails, extras, partyBooking, bookingType, depositAmount);
      } else {
        topUpPaymentGA(bookingId, topUpAmount);
      }
      break;
    }
    case POST_PAYMENT + FAILURE: {
      const state = store.getState();
      const error = postPaymentErrorDataSelector(state);
      paymentErrorGA(error?.message, error?.status);
      break;
    }
    case SELECT_PARK: {
      const state = store.getState();
      const parkDetails = parkDetailsSelector(state);

      const searchResult = /(park-result|boat-result)/.test(location.pathname);

      const processedResults = processedResultsSelector(state);
      const selectedResult = processedResults?.selectedDate;

      if (searchResult && selectedResult?.lowestPrice) {
        viewItemGA(selectedResult.lowestPrice, parkDetails);
      }

      break;
    }
    case ACCOM_UPDATE_MIN_VALUE: {
      accomUpdateMinPriceGA(action.payload);
      break;
    }
    case ACCOM_UPDATE_MAX_VALUE: {
      accomUpdateMaxPriceGA(action.payload);
      break;
    }
    case UPDATE_MIN_VALUE: {
      updateMinPriceGA(action.payload);
      break;
    }
    case UPDATE_MAX_VALUE: {
      updateMaxPriceGA(action.payload);
      break;
    }
    case ACCOM_UPDATE_BEDROOMS: {
      accomUpdateBedroomsGA(action.payload);
      break;
    }
    case ACCOM_UPDATE_BATHROOMS: {
      accomUpdateBathroomsGA(action.payload);
      break;
    }
    case TOGGLE_PET_FRIENDLY_SELECTED: {
      const state = store.getState();
      const petFriendlySelected = petFriendlySelectedSelector(state);
      togglePetFriendlyGA(!petFriendlySelected);
      break;
    }
    case ACCOM_TOGGLE_FILTER: {
      const feature = action.payload;
      const state = store.getState();
      const accomFiltersStateArray = accomFiltersStateArraySelector(state);
      const isFeatureAlreadyOn = accomFiltersStateArray.includes(feature);
      accomFeatureGA(feature, !isFeatureAlreadyOn);
      break;
    }
    default:
      break;
  }

  return next(action);
};
